<template>
  <div class="panel-body">
    <div class="text-size-20">
      <h1><b>準備中</b></h1>
    </div>
  </div>
</template>

<script>
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.delivery_tab.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseSc/DeliveryStatusInquiry.vue